export const locales = [
	'en-us',
	'en-ca',
	'fr-ca',
	'en-gb',
	'en-de',
	'en-dk',
	'en-id',
	'en-ph',
	'en-pl',
	'de-de',
	'es-es',
	'it-it',
	'nl-nl',
	'nl-be',
	'fr-be',
	'fr-fr',
	'en-at',
	'en-be',
	'en-pt',
	'en-it',
	'en-es',
	'en-fr',
	'en-se',
	'en-no',
	'en-ch',
	'en-hk',
	'en-au',
	'en-my',
	'en-sg',
	'en-th',
	'en-ie',
	'en-nl',
	'fr-ch',
	'de-at',
	'de-ch',
	'it-ch',
	'ko-kr',
	'es-mx',
	'pl-pl',
	'zh-hk',
	'th-th',
] as const

export const allCountryCodesByRegion = {
	EMEA: [
		{ code: 'AL', name: 'Albania' },
		{ code: 'DZ', name: 'Algeria' },
		{ code: 'AD', name: 'Andorra' },
		{ code: 'AM', name: 'Armenia' },
		{ code: 'AT', name: 'Austria' },
		{ code: 'AZ', name: 'Azerbaijan' },
		{ code: 'BH', name: 'Bahrain' },
		{ code: 'BY', name: 'Belarus' },
		{ code: 'BE', name: 'Belgium' },
		{ code: 'BA', name: 'Bosnia and Herzegovina' },
		{ code: 'BG', name: 'Bulgaria' },
		{ code: 'CY', name: 'Cyprus' },
		{ code: 'HR', name: 'Croatia' },
		{ code: 'CZ', name: 'Czech Republic' },
		{ code: 'DK', name: 'Denmark' },
		{ code: 'EG', name: 'Egypt' },
		{ code: 'EE', name: 'Estonia' },
		{ code: 'FI', name: 'Finland' },
		{ code: 'FR', name: 'France' },
		{ code: 'GE', name: 'Georgia' },
		{ code: 'DE', name: 'Germany' },
		{ code: 'GR', name: 'Greece' },
		{ code: 'HU', name: 'Hungary' },
		{ code: 'IS', name: 'Iceland' },
		{ code: 'IR', name: 'Iran' },
		{ code: 'IQ', name: 'Iraq' },
		{ code: 'IE', name: 'Ireland' },
		{ code: 'IL', name: 'Israel' },
		{ code: 'IT', name: 'Italy' },
		{ code: 'JO', name: 'Jordan' },
		{ code: 'KZ', name: 'Kazakhstan' },
		{ code: 'XK', name: 'Kosovo' },
		{ code: 'KW', name: 'Kuwait' },
		{ code: 'KG', name: 'Kyrgyzstan' },
		{ code: 'LV', name: 'Latvia' },
		{ code: 'LB', name: 'Lebanon' },
		{ code: 'LY', name: 'Libya' },
		{ code: 'LI', name: 'Liechtenstein' },
		{ code: 'LT', name: 'Lithuania' },
		{ code: 'LU', name: 'Luxembourg' },
		{ code: 'MT', name: 'Malta' },
		{ code: 'MD', name: 'Moldova' },
		{ code: 'MC', name: 'Monaco' },
		{ code: 'ME', name: 'Montenegro' },
		{ code: 'MA', name: 'Morocco' },
		{ code: 'NL', name: 'Netherlands' },
		{ code: 'MK', name: 'North Macedonia' },
		{ code: 'NO', name: 'Norway' },
		{ code: 'OM', name: 'Oman' },
		{ code: 'PS', name: 'Palestine' },
		{ code: 'PL', name: 'Poland' },
		{ code: 'PT', name: 'Portugal' },
		{ code: 'QA', name: 'Qatar' },
		{ code: 'RO', name: 'Romania' },
		{ code: 'RU', name: 'Russia' },
		{ code: 'SM', name: 'San Marino' },
		{ code: 'SA', name: 'Saudi Arabia' },
		{ code: 'RS', name: 'Serbia' },
		{ code: 'SK', name: 'Slovakia' },
		{ code: 'SI', name: 'Slovenia' },
		{ code: 'ZA', name: 'South Africa' },
		{ code: 'ES', name: 'Spain' },
		{ code: 'SD', name: 'Sudan' },
		{ code: 'SE', name: 'Sweden' },
		{ code: 'CH', name: 'Switzerland' },
		{ code: 'SY', name: 'Syria' },
		{ code: 'TN', name: 'Tunisia' },
		{ code: 'TR', name: 'Turkey' },
		{ code: 'TM', name: 'Turkmenistan' },
		{ code: 'UA', name: 'Ukraine' },
		{ code: 'AE', name: 'United Arab Emirates' },
		{ code: 'GB', name: 'United Kingdom' },
		{ code: 'UZ', name: 'Uzbekistan' },
		{ code: 'VA', name: 'Vatican City' },
		{ code: 'YE', name: 'Yemen' },
	],
	APAC: [
		{ code: 'AU', name: 'Australia' },
		{ code: 'BD', name: 'Bangladesh' },
		{ code: 'BN', name: 'Brunei' },
		{ code: 'KH', name: 'Cambodia' },
		{ code: 'CN', name: 'China' },
		{ code: 'HK', name: 'Hong Kong' },
		{ code: 'ID', name: 'Indonesia' },
		{ code: 'IN', name: 'India' },
		{ code: 'JP', name: 'Japan' },
		{ code: 'MY', name: 'Malaysia' },
		{ code: 'NZ', name: 'New Zealand' },
		{ code: 'PH', name: 'Philippines' },
		{ code: 'SG', name: 'Singapore' },
		{ code: 'TH', name: 'Thailand' },
		{ code: 'TW', name: 'Taiwan' },
		{ code: 'VN', name: 'Vietnam' },
	],
	LATAM: [
		{ code: 'AR', name: 'Argentina' },
		{ code: 'BO', name: 'Bolivia' },
		{ code: 'BR', name: 'Brazil' },
		{ code: 'CL', name: 'Chile' },
		{ code: 'CO', name: 'Colombia' },
		{ code: 'CR', name: 'Costa Rica' },
		{ code: 'DO', name: 'Dominican Republic' },
		{ code: 'EC', name: 'Ecuador' },
		{ code: 'SV', name: 'El Salvador' },
		{ code: 'GT', name: 'Guatemala' },
		{ code: 'HN', name: 'Honduras' },
		{ code: 'MX', name: 'Mexico' },
		{ code: 'NI', name: 'Nicaragua' },
		{ code: 'PA', name: 'Panama' },
		{ code: 'PY', name: 'Paraguay' },
		{ code: 'PE', name: 'Peru' },
		{ code: 'PR', name: 'Puerto Rico' },
		{ code: 'UY', name: 'Uruguay' },
		{ code: 'VE', name: 'Venezuela' },
	],
	NORTH_AMERICA: [
		{ code: 'CA', name: 'Canada' },
		{ code: 'US', name: 'United States' },
		{ code: 'MX', name: 'Mexico' },
	],
}
export type Locale = (typeof locales)[number]

export const prerenderLocales = locales.filter((locale) => locale === 'en-us')

export const startingLocationByLocale = {
	'en-us': {
		value: 'Baltimore, MD',
		latitude: 39.390897,
		longitude: -76.610722,
	},
	'en-ca': {
		value: 'Toronto, ON',
		latitude: 43.65107,
		longitude: -79.347015,
	},
	'fr-ca': {
		value: 'Montreal, QC',
		latitude: 45.501689,
		longitude: -73.567256,
	},
	'fr-fr': {
		value: 'Paris, FR',
		latitude: 48.856614,
		longitude: 2.352222,
	},
	'de-de': {
		value: 'Berlin, DE',
		latitude: 52.52,
		longitude: 13.405,
	},
	'es-es': {
		value: 'Madrid, ES',
		latitude: 40.416775,
		longitude: -3.70379,
	},
	'it-it': {
		value: 'Rome, IT',
		latitude: 41.90332,
		longitude: 12.45339,
	},
	'nl-be': {
		value: 'Brussels, BE',
		latitude: 50.8503,
		longitude: 4.3517,
	},
	'fr-be': {
		value: 'Brussels, BE',
		latitude: 50.8503,
		longitude: 4.3517,
	},
	'nl-nl': {
		value: 'Amsterdam, NL',
		latitude: 52.372776,
		longitude: 4.892222,
	},
	'en-nl': {
		value: 'Amsterdam, NL',
		latitude: 52.372776,
		longitude: 4.892222,
	},
	'en-gb': {
		value: 'London, England',
		latitude: 51.507351,
		longitude: -0.127758,
	},
	'en-at': {
		value: 'Vienna, AT',
		latitude: 48.2082,
		longitude: 16.3738,
	},
	'en-ie': {
		value: 'Dublin, IE',
		latitude: 53.3498,
		longitude: -6.2603,
	},
	'en-be': {
		value: 'Brussels, BE',
		latitude: 50.8503,
		longitude: 4.3517,
	},
	'en-pt': {
		value: 'Lisbon, PT',
		latitude: 38.7223,
		longitude: -9.1393,
	},
	'en-it': {
		value: 'Rome, IT',
		latitude: 41.90332,
		longitude: 12.45339,
	},
	'en-es': {
		value: 'Madrid, ES',
		latitude: 40.416775,
		longitude: -3.70379,
	},
	'en-fr': {
		value: 'Paris, FR',
		latitude: 48.856614,
		longitude: 2.352222,
	},
	'en-se': {
		value: 'Stockholm, SE',
		latitude: 59.3293,
		longitude: 18.0686,
	},
	'en-no': {
		value: 'Oslo, NO',
		latitude: 59.9139,
		longitude: 10.7522,
	},
	'en-ch': {
		value: 'Zurich, CH',
		latitude: 47.3769,
		longitude: 8.5417,
	},
	'en-hk': {
		value: 'Hong Kong, HK',
		latitude: 22.3193,
		longitude: 114.1694,
	},
	'en-au': {
		value: 'Sydney, AU',
		latitude: -33.8688,
		longitude: 151.2093,
	},
	'en-my': {
		value: 'Kuala Lumpur, MY',
		latitude: 3.139,
		longitude: 101.6869,
	},
	'en-sg': {
		value: 'Singapore, SG',
		latitude: 1.3521,
		longitude: 103.8198,
	},
	'en-th': {
		value: 'Bangkok, TH',
		latitude: 13.7563,
		longitude: 100.5018,
	},
	'fr-ch': {
		value: 'Zurich, CH',
		latitude: 47.3769,
		longitude: 8.5417,
	},
	'de-at': {
		value: 'Vienna, AT',
		latitude: 48.2082,
		longitude: 16.3738,
	},
	'de-ch': {
		value: 'Zurich, CH',
		latitude: 47.3769,
		longitude: 8.5417,
	},
	'it-ch': {
		value: 'Zurich, CH',
		latitude: 47.3769,
		longitude: 8.5417,
	},
	'ko-kr': {
		value: 'Seoul, KR',
		latitude: 37.5665,
		longitude: 126.978,
	},
	'es-mx': {
		value: 'Mexico City, MX',
		latitude: 19.4326,
		longitude: -99.1332,
	},
	'pl-pl': {
		value: 'Warsaw, PL',
		latitude: 52.2297,
		longitude: 21.0122,
	},
	'zh-hk': {
		value: 'Hong Kong, HK',
		latitude: 22.3193,
		longitude: 114.1694,
	},
	'th-th': {
		value: 'Bangkok, TH',
		latitude: 13.7563,
		longitude: 100.5018,
	},
	'en-de': {
		value: 'Berlin, DE',
		latitude: 52.52,
		longitude: 13.405,
	},
	'en-dk': {
		value: 'Copenhagen, DK',
		latitude: 55.6761,
		longitude: 12.5683,
	},
	'en-id': {
		value: 'Jakarta, ID',
		latitude: -6.2089,
		longitude: 106.8456,
	},
	'en-ph': {
		value: 'Manila, PH',
		latitude: 14.5995,
		longitude: 120.9842,
	},
	'en-pl': {
		value: 'Warsaw, PL',
		latitude: 52.2297,
		longitude: 21.0122,
	},
}

export const getStartingLocationByLocale = (locale: Locale) => {
	return startingLocationByLocale[locale] || startingLocationByLocale['en-us']
}

export const getCountryCodesForSupportedLocales = () => {
	const countryCodesWithDupes = locales.map((locale) => {
		const countryCode = locale.split('-')[1]
		return countryCode.toUpperCase()
	})
	return [...new Set(countryCodesWithDupes)]
}

export const getAllPossibleCountryCodes = () => {
	const countryCodes = allCountryCodesByRegion.EMEA.concat(
		allCountryCodesByRegion.APAC,
		allCountryCodesByRegion.LATAM,
		allCountryCodesByRegion.NORTH_AMERICA,
	)

	const countryCodesWithoutDupes = [...new Set(countryCodes.map((country) => country.code))]

	return countryCodesWithoutDupes
}

export const getCountryCodesByRegion = (region: keyof typeof allCountryCodesByRegion) => {
	return allCountryCodesByRegion[region]
}
